import { RootState } from "../../app";
import { createSelector } from "@reduxjs/toolkit";
import { selectConfigMapCategorizations } from "../../configMap/selectors/categorizationLinkSelectors";

const selectConfigMap = (state: RootState) => state.configMapReducer.configMap;

const selectCategorizationAnnotations = (state: RootState) =>
  state.metadataReducer.categorizationState.categorizationAnnotations || [];

const selectHasMissingCategorizations = createSelector(
  selectConfigMap,
  selectCategorizationAnnotations,
  (configMap, categorizationAnnotations): boolean => {
    if (!configMap) {
      return false;
    }

    const configMapCategorizations = selectConfigMapCategorizations(configMap);

    return configMapCategorizations
      .filter((cwc) => cwc.required)
      .map((cwc): boolean => {
        const found = categorizationAnnotations.find(
          (ca) => ca.categorizationId === cwc.categorization.id,
        );

        return !!found;
      })
      .includes(false);
  },
);

export default selectHasMissingCategorizations;
